export enum UnitTypeEnum {
  KWH = 'kWh',
  LITER = 'l',
  CUBIC_METER = 'm³',
  UNDEFINED = 'undefined',
}
